import { FieldProps } from 'formik';
import React, { FocusEvent } from 'react';
import { CloseIcon, InfoImage } from 'src/assets/images';
import { FloatingInputVersionTwo, Tooltip } from 'src/components';
import {
  LinkName,
  PageName,
  PaymentRequestTealiumService,
  UIInteractionType,
} from 'src/containers/self-service/generate-payment-request/tagging/payment-request-tealium-service';
import { NotificationMethod, PaymentType } from 'src/services/payment-request-service';

interface Props extends FieldProps {
  icon: React.ReactNode;
  tooltip?: string;
  className?: string;
  onBlurred: (e: FocusEvent<HTMLInputElement>) => void;
}

export function tagOnFocus(notificationMethod: NotificationMethod, paymentType: PaymentType) {
  const link =
    paymentType === PaymentType.FixedAmount
      ? LinkName.GENERATE_PAYMENT_REQUEST_NOTIFICATION_METHOD_FIXED
      : LinkName.GENERATE_PAYMENT_REQUEST_NOTIFICATION_METHOD_VARIABLE;
  const page =
    paymentType === PaymentType.FixedAmount
      ? PageName.GENERATE_PAYMENT_REQUEST_DETAILS_FIXED
      : PageName.GENERATE_PAYMENT_REQUEST_DETAILS_VARIABLE;

  PaymentRequestTealiumService.onUIInteraction(
    link,
    NotificationMethod.Email === notificationMethod
      ? UIInteractionType.EmailEntered
      : UIInteractionType.PhoneEntered,
    '',
    page,
  );
}

export function TextInput({ form, icon, ...props }: Props) {
  return (
    <section className={`relative ${props.className}`}>
      <FloatingInputVersionTwo icon={icon} form={form} {...props} onBlur={props.onBlurred} />
      <div className="absolute top-5 right-4">
        {props.tooltip && (
          <Tooltip showOnHover isMobile={false} lightMode content={props.tooltip}>
            <img className="w-5 h-5 cursor-pointer" src={InfoImage} alt="info" />
          </Tooltip>
        )}
        {props.field.value && (
          <img
            onClick={() => form.setFieldValue(props.field.name, '')}
            className="w-5 h-5 cursor-pointer"
            src={CloseIcon}
            alt="clear"
          />
        )}
      </div>
    </section>
  );
}
